import { FunctionComponent } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoltLightning } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import styles from './TriggerNode.module.scss';

export interface TriggerNodeData {
    label?: string;
    subtitle?: string;
    chips?: string[];
    selected?: boolean;
    [key: string]: unknown;
}

const TriggerNode: FunctionComponent<NodeProps> = ({ data, selected }) => {
    const nodeData = data as TriggerNodeData;

    return (
        <>
            <Handle
                type="source"
                position={Position.Bottom}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <div className={clsx(styles.node, { [styles.selected]: selected })}>
                <div className={styles.iconCircle}>
                    <FontAwesomeIcon icon={faBoltLightning} />
                </div>
                <div className={styles.content}>
                    <span className={styles.title}>{nodeData.label ?? 'Trigger'}</span>
                    {nodeData.subtitle && (
                        <span
                            className={clsx(styles.subtitle, {
                                [styles.subtitleActive]: nodeData.subtitle !== 'Select a trigger'
                            })}
                        >
                            {nodeData.subtitle}
                        </span>
                    )}
                    {nodeData.chips && nodeData.chips.length > 0 && (
                        <div className={styles.chips}>
                            <span className={styles.chip}>{nodeData.chips[0]}</span>
                            {nodeData.chips.length > 1 && (
                                <span className={styles.chipMore}>+{nodeData.chips.length - 1}</span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default TriggerNode;
